export default "__VITE_ASSET__XYa60TjY__"